<template>
  <div class="hello">
    
    
    <iframe :src="url" :width="width" :height="height" frameBorder="0"></iframe>

    <div @click="goBack()">Go Back</div>
  </div>
</template>

<script>

export default {
  name: 'Game',
  props: {
    url: String,
    width: { type:Number, default:660 },
    height: { type:Number, default:500 }
  },
  methods: {
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
